import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { AppData } from '../../types';
import { downloadJSON } from '../../utils/export';
import { Download, Save } from 'lucide-react';
interface ProfileTabProps {
  data: AppData;
  onUpdateProfile: (profile: any) => void;
}
export function ProfileTab({
  data,
  onUpdateProfile
}: ProfileTabProps) {
  const [formData, setFormData] = useState(data.profile);
  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    onUpdateProfile(formData);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };
  return <div className="max-w-2xl mx-auto space-y-8" data-id="element-319">
      <div className="flex flex-col items-center mb-8" data-id="element-320">
        <div className="w-24 h-24 rounded-full bg-primary-gradient flex items-center justify-center text-white text-4xl font-bold mb-4 shadow-lg" data-id="element-321">
          {formData.name ? formData.name.charAt(0).toUpperCase() : 'U'}
        </div>
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-322">
          {formData.name || 'User Profile'}
        </h2>
        <p className="text-gray-500" data-id="element-323">
          Manage your personal information and data
        </p>
      </div>

      <Card data-id="element-324">
        <h3 className="text-lg font-bold text-gray-900 mb-6 border-b pb-2" data-id="element-325">
          Personal Information
        </h3>
        <div className="space-y-4" data-id="element-326">
          <Input label="Full Name" value={formData.name} onChange={e => setFormData({
          ...formData,
          name: e.target.value
        })} data-id="element-327" />
          <Input label="Email Address" type="email" value={formData.email} onChange={e => setFormData({
          ...formData,
          email: e.target.value
        })} data-id="element-328" />
          <Input label="Phone Number" type="tel" value={formData.phone} onChange={e => setFormData({
          ...formData,
          phone: e.target.value
        })} data-id="element-329" />
          <Input multiline label="Brief Case Description" placeholder="A short summary of your situation..." value={formData.caseDescription} onChange={e => setFormData({
          ...formData,
          caseDescription: e.target.value
        })} data-id="element-330" />

          <div className="pt-4 flex justify-end" data-id="element-331">
            <Button onClick={handleSave} leftIcon={<Save className="w-4 h-4" data-id="element-333" />} data-id="element-332">
              {saved ? 'Saved!' : 'Save Profile'}
            </Button>
          </div>
        </div>
      </Card>

      <Card className="bg-gray-50 border-gray-200" data-id="element-334">
        <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-335">
          Data Management
        </h3>
        <p className="text-sm text-gray-600 mb-6" data-id="element-336">
          Download a complete backup of all your data including incidents,
          evidence metadata, people, and check-ins.
        </p>
        <Button variant="outline" className="w-full bg-white text-gray-700 border-gray-300 hover:bg-gray-50" onClick={() => downloadJSON(data)} leftIcon={<Download className="w-4 h-4" data-id="element-338" />} data-id="element-337">
          Export All Data (JSON)
        </Button>
      </Card>
    </div>;
}